module.exports = __webpack_public_path__ + "static/media/logo.e140299a.png";